module.exports = __webpack_public_path__ + "LS.b12db47b.png";